import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router'
import LoadIcon from 'src/components/LoadIcon'
import { loginUser } from 'src/ducks/auth'
import routes from 'src/routes'
import styled from 'styled-components'

const Page = styled.div`
  height: 100vh;
  width: 100vw;
`

export const SingleSignOnHandler = (props) => {
  const { isSsoLoading } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const queryParams = new URLSearchParams(props.location.search)
  const ssoToken = queryParams.get('token')

  React.useEffect(() => {
    if (ssoToken && ssoToken.length) {
      loginUser(dispatch, { sso_token: ssoToken }, true)
    }
  }, [dispatch, ssoToken])

  if (isSsoLoading) {
    return (
      <Page id="innerBody">
        <LoadIcon loadingText="Logging in..." />
      </Page>
    )
  } else {
    return <Redirect to={routes.lobby} />
  }
}
